import { createContext } from 'react';
import { type IDetailItemInfo } from '@interface/IDetail';

export const ItemDataContext = createContext<IDetailItemInfo | null>(null);
